<template lang="html">
  <div id="contact-page">

    <section class="container main-section">
      <div class="row justify-content-center align-items-center">
        <div class="col-12 col-title">
          <h1 class="title-s1">Contact</h1>
        </div>

        <!-- <div class="col-lg-6 col-info">
          <h5 class="title">¿Tienes preguntas?<br />Envíanos un mensaje o comunicate con nosotros.</h5>

          <h5 class="mt-3 subtitle">Dirección Matriz</h5>
          <p>
            Calle 1 #123<br />
            Guadalajara, Jalisco<br />
            México.
          </p>

          <h5 class="mt-3 subtitle">Teléfono</h5>
          <p>
            Tel. 55 323-4332-9438
          </p>

          <h5 class="mt-3 subtitle">Correo</h5>
          <p>
            contacto@necesitolentes.club
          </p>

          <h5 class="mt-3 subtitle">Síguenos</h5>
          <p>
            <a class="btn-network mr-1" href=""><i class="fab fa-instagram"></i></a>
            <a class="btn-network ml-1" href=""><i class="fab fa-twitter"></i></a>
            <a class="btn-network ml-1" href=""><i class="fab fa-facebook-f"></i></a>
            <a class="btn-network ml-1" href="#"><i class="fab fa-linkedin-in"></i></a>
          </p>
        </div> -->

        <div class="col-lg-6 col-form">
          <b-form @submit="onSubmit">
            <b-form-group class="custom-form-group-s1" label="Full name">
              <b-form-input type="text" size="sm" v-model="form.name" required placeholder=""></b-form-input>
            </b-form-group>

            <b-form-group class="custom-form-group-s1" label="Email">
              <b-form-input type="email" size="sm" v-model="form.email" required placeholder=""></b-form-input>
            </b-form-group>

            <b-form-group class="custom-form-group-s1" label="Phone">
              <b-form-input type="text" size="sm" v-model="form.phone" minlength="10" maxlength="10" required placeholder=""></b-form-input>
            </b-form-group>

            <b-form-group class="custom-form-group-s1" label="Message">
              <b-form-textarea
                required
                v-model="form.msg"
                size="sm"
                placeholder=""
                rows="4"
                max-rows="4"
              ></b-form-textarea>
            </b-form-group>

            <p class="text-right">
              <b-button type="submit" class="btn-s1 primary br-10">SEND</b-button>
            </p>
          </b-form>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  data(){
    return{
      form: {
        name: null,
        msg:null,
      }
    }
  },

  methods: {
    makeToast(variant = null, msg, title) {
      this.$bvToast.toast(msg, {
        title: title,
        variant: variant,
        solid: true,
        toaster: 'b-toaster-bottom-right',
        appendToast: true
      })
    },

    onSubmit(event) {
      event.preventDefault();

      var params = this.form;
      var apiURL = tools.url("/api/contact");

      axios.post( apiURL,params )
      .then( (response) => {
        // alert(response.data.response);
        this.makeToast('success', response.data.response, 'Mensaje enviado');
        // alert(response.data.response);

        for (let prop in this.form) {
          this.form[prop] = '';
        }
      })
      .catch( (error) => {
        // console.log(error.response.data);
        let errors = error.response.data;

        for (let prop in errors) {
          // console.log(errors[prop]);
          this.makeToast('danger', errors[prop], '¡Error!');
        }
      });
    },
  },
  mounted(){
      if(this.$route.query.data){
          this.form.msg = this.$route.query.data;
      }
  }
}
</script>
